export class GeneralApiError extends Error {
  readonly type?: string;
  readonly responseStatus?: number;
  readonly responseBody?: string;
  constructor(responseStatus?: number, responseBody?: string) {
    super('An unexpected error occurred.');
    this.type = 'GeneralApiError';
    this.responseStatus = responseStatus;
    this.responseBody = responseBody;
  }
}
